import React from 'react';
import { useSelector } from 'react-redux';
import RetailerImage from '../../common/RetailerImage';

import styles from './ActivationHeader.module.scss';

export function ActivationHeader() {
  const { supplier, supplierRetailer } = useSelector((state) => state.activation);
  const { square_logo_path, name } = supplier;

  const isActive = !!supplierRetailer.approved_for_ecommerce;

  return (
    <div className={styles.container}>
      <div className={styles.image}>
        <RetailerImage image={square_logo_path} name={name} size="200" />
      </div>

      <div>
        <h1>{name}</h1>

        <div className={styles.info}>
          <label>Seller status:</label>
          <span className={isActive ? styles.active : styles.inactive}>{isActive ? 'Active' : 'Inactive'}</span>
        </div>
      </div>
    </div>
  );
}
